'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var range = {};

exports.__exports = range;
